import React, { useEffect, useState } from "react";
import Layout from "../../components/layout/Layout";
import { Briefcase, Eye, MessageTick, User } from "iconsax-react";
import { ErrorMessage, Field, Form, Formik } from "formik";
import useProfileLogic from "./useProfileLogic";
import useRolesLogic from "../Users/Roles/useRolesLogic";
import { v4 } from "uuid";
import { toast } from "react-toastify";

function Profile() {
  const {
    fetchProfile,
    updateProfile,
    profileValidationSchema,
    uploadAvatar,
    profile,
  } = useProfileLogic();
  const { rolesList } = useRolesLogic();
  console.log({ fetchProfile });

  return (
    <Layout pageName="Profile" icon={<User size="32" color="#071839" />}>
      <section className="mt-5">
        <div className="flex items-center justify-between bg-white p-4 rounded-md">
          {/* {profile.profile_picture} */}
          <div className="avatar placeholder rounded-full">
            <div className="w-20 bg-neutral text-neutral-content rounded-full">
              {/* {profile.email} */}
              {!profile.profile_picture ? (
                <span>AD</span>
              ) : (
                <img
                  src={profile.profile_picture}
                  alt={fetchProfile.data?.data.admin.name}
                />
              )}
            </div>
          </div>

          <div className="w-full mx-4">
            <h4 className="text-[#4E5566] text-2xl font-semibold">
              {fetchProfile.data?.data?.admin?.name}
            </h4>
            <p>{fetchProfile.data?.data.role.name}</p>
            <p>
              Date Created:{" "}
              {new Date(
                fetchProfile.data?.data.admin.createdAt || ""
              ).toLocaleDateString()}
            </p>
          </div>
          <div className="flex gap-2">
            <div className="">
              <label className="btn pointer w-max bg-primary text-white">
                Upload New Photo
                <input
                  type="file"
                  hidden
                  onChange={(e) => {
                    uploadAvatar(profile, e.target.files?.[0]);
                  }}
                />
              </label>
            </div>
            <div className="">
              <button className="btn w-max btn-outline text-primary">
                Deactivate Account
              </button>
            </div>
          </div>
        </div>

        <div className="">
          <Formik
            initialValues={{
              email: fetchProfile.data?.data.admin.email || "",
              name: fetchProfile.data?.data.admin.name || "",
              password: "",
              current_password: "",
              profile_picture: "",
              role_id: fetchProfile.data?.data?.role?.id || "",
              user_id: "5",
            }}
            enableReinitialize
            onSubmit={(values, { setSubmitting }) => {
              updateProfile.mutate(values, {
                onSuccess: (response) => {
                  toast.dismiss();
                  toast.success(`Updated Profile Successfully`);
                  fetchProfile.refetch();
                },
                onError: (error: any) => {
                  toast.dismiss();
                  toast.error(`${error?.response.data.message}`);
                },
              });
            }}
            validationSchema={profileValidationSchema}
          >
            {() => (
              <Form className="mt-5 p-5 rounded-md bg-white">
                <div className="grid grid-cols-2 gap-2 lg:gap-4">
                  <label className="input input-bordered flex items-center gap-2">
                    <User size={16} color="#071839" />
                    <Field
                      name="name"
                      className="grow"
                      placeholder="Fullname"
                    />
                  </label>
                  {/* <label className="input input-bordered flex items-center gap-2">
                    <User size={16} color="#071839" />
                    <Field
                      name="lastname"
                      className="grow"
                      placeholder="Lastname"
                    />
                  </label> */}
                  <label className="input input-bordered flex items-center gap-2">
                    <MessageTick size={16} color="#071839" />
                    <Field name="email" placeholder="Email" className="grow" />
                  </label>
                  <label className="join border px-2 flex items-center gap-2">
                    <Briefcase size={16} color="#071839" />
                    <Field
                      as="select"
                      name="role_id"
                      className="grow select focus:border-none focus:outline-none select-border"
                      placeholder="Lastname"
                      defaultValue=" "
                    >
                      <option value="" disabled>
                        Select Role
                      </option>
                      {rolesList.data?.data.map((role) => (
                        <option key={v4()} value={role.id}>
                          {role.name}
                        </option>
                      ))}
                    </Field>
                  </label>{" "}
                  <label className="input input-bordered flex items-center gap-2">
                    <Eye size={16} color="#071839" />
                    <Field
                      type="password"
                      name="current_password"
                      placeholder="Current Password"
                      className="grow"
                    />
                  </label>{" "}
                  <label className="input input-bordered flex items-center gap-2">
                    <Eye size={16} color="#071839" />
                    <Field
                      type="password"
                      name="password"
                      placeholder="New Password"
                      className="grow"
                    />
                  </label>{" "}
                  <label className="input input-bordered flex items-center gap-2">
                    <Eye size={16} color="#071839" />
                    <Field
                      type="password"
                      name="confirm_password"
                      placeholder="Confirm New Password"
                      className="grow"
                    />
                  </label>{" "}
                  <ErrorMessage
                    component={"p"}
                    name="confirm_password"
                    className="font-xs text-red-500"
                  />
                </div>
                <div className="flex justify-center mt-4">
                  <button type="submit" className="btn bg-primary text-white">
                    Save Changes
                  </button>
                </div>
              </Form>
            )}
          </Formik>
        </div>
      </section>
    </Layout>
  );
}

export default Profile;
